import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { map, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { RouterActions } from './router.actions';
import { HttpHelper } from '@lib/utils/helpers/http-helper/http-helper';
import { IS_SERVER } from '@core/config';

@Injectable()
export class RouterEffects {
  constructor(@Inject(IS_SERVER) private isServer: boolean, private actions$: Actions, private router: Router) {}

  navigate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RouterActions.navigate),
        tap(({ url, fragment, queryParams }) => {
          if (!this.isServer && url?.toLowerCase()?.startsWith('http')) {
            const target = HttpHelper.buildUrl(url, queryParams, fragment);

            if (target) {
              location.href = target;
            }

            return;
          }

          this.router.navigate([url], { fragment, queryParams }).then();
        }),
        map(() => null)
      ),
    { dispatch: false }
  );
}
